import { render, staticRenderFns } from "./pullNewCard.vue?vue&type=template&id=1690fec6&scoped=true&"
import script from "./pullNewCard.vue?vue&type=script&lang=js&"
export * from "./pullNewCard.vue?vue&type=script&lang=js&"
import style0 from "./pullNewCard.vue?vue&type=style&index=0&id=1690fec6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1690fec6",
  null
  
)

export default component.exports